import React from "react";
import { withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from "prop-types";
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import AppartmentIcon from '@material-ui/icons/Apartment';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import moment from "moment";
import * as helper from "../common/helper";
import SelectTable from './SelectTable';
import * as i18n from "../common/i18n";
import * as graphql from '../common/graphql';
import gql from 'graphql-tag';
import Message from "./Message";
import Grid from '@material-ui/core/Grid';
import "moment/locale/de";


moment.locale("de");

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: 'inline',
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: 200,
    },
});


class TapWizard extends React.Component {
    constructor(props) {

        super(props);

        this.state = {
            message: null,
            activeStep: 0,
            tapName: null,
            valveName: null,
            faucetName: null,
            tenant: null,
            tenantDetails: {},
            building: null,
            buildingDetails: {},
            parcel: null,
            parcelDetails: {},
            steps: this.getSteps(),
            details: null,
            hideAfter: 3000,
            variant: "info",
            search: "",
        };
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    onAddBuilding = (data) => {
        this.setState({
            building: data.id,
            buildingDetails: data
        });
    }

    onDeleteBuilding = (data) => {
        this.setState({
            building: null,
            buildingDetails: {}
        });
    }

    onAddParcel = (data) => {
        this.setState({
            parcel: data.id,
            parcelDetails: data
        });
    }

    onDeleteParcel = (data) => {
        this.setState({
            parcel: null,
            parcelDetails: data
        });
    }

    onAddTapName = (data) => {
        this.setState({
            tapName: data,
        });
    }

    onAddTenant = (data) => {
        this.setState({
            tenant: data.id,
            tenantDetails: data
        });
    }

    onDeleteTenant = (data) => {
        this.setState({
            tenant: null,
            tenantDetails: {}
        });
    }
    onClose = () => {
        this.props.onCancel();
        this.reset();
    }

    onPrevious = () => {
        const activeStep = this.state.activeStep - 1;
        this.setState({ activeStep: activeStep })
    }

    onNext = async () => {
        const activeStep = this.state.activeStep + 1;
        this.setState({ activeStep: activeStep })
    }

    nextPossible = () => {
        switch (this.state.activeStep) {
            case 3:
                return this.state.tenant !== null
            case 4:
                return this.state.building !== null
            case 5:
                return this.state.parcel !== null

            default:
                return true;
        }
    }

    onSave = () => {
        this.props.onSave(
            {
                parcel: this.state.parcel,
                name: this.state.tapName,
                valve: this.state.valveName,
                faucet: this.state.faucetName,
                building: this.state.building,
                tenant: this.state.tenant,
            }
        );
        this.onClose();
    }

    reset = () => {
        this.setState(
            {
                message: null,
                activeStep: 0,
                tapName: null,
                valveName: null,
                faucetName: null,
                tenant: null,
                tenantDetails: {},
                building: null,
                buildingDetails: {},
                parcel: null,
                parcelDetails: {},
                steps: this.getSteps(),
                details: null,
                hideAfter: 3000,
                variant: "info",
                search: "",
            }
        )
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    getSteps = () => {
        return [i18n.get("tapWizard.step.0"), i18n.get("tapWizard.step.1"), i18n.get("tapWizard.step.2"), i18n.get("tapWizard.step.3"), i18n.get("tapWizard.step.4"), i18n.get("tapWizard.step.5"), i18n.get("tapWizard.step.6")];
    }

    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return this.setTapName();
            case 1:
                return this.setValveName();
            case 2:
                return this.setFaucetName();
            case 3:
                return this.selectTenant();
            case 4:
                return this.selectBuilding();
            case 5:
                return this.selectParcel();
            case 6:
                return this.showSummary();
            default:
                return 'Error';
        }
    }

    showSummary = () => {

        const data = [
            { label: i18n.get("tapWizard.summary.room"), value: `${this.state.tapName}` },
            { label: i18n.get("tapWizard.summary.valve"), value: `${this.state.valveName}` },
            { label: i18n.get("tapWizard.summary.faucet"), value: `${this.state.faucetName}` },
            { label: i18n.get("tapWizard.summary.tenant"), value: `${this.state.tenantDetails.company}` },
            { label: i18n.get("tapWizard.summary.building"), value: `${this.state.buildingDetails.street}` },
            { label: i18n.get("tapWizard.summary.parcel"), value: this.state.parcelDetails.name },
        ]

        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="md">

                    <Grid
                        container={true}
                        spacing={1}
                        justify={'center'}
                    >

                        {data && data.map(d =>
                            <React.Fragment>
                                <Grid item xs={12} lg={6}>
                                    <b>{d.label}</b>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    {d.value}
                                </Grid>
                            </React.Fragment>
                        )}

                    </Grid>

                </Container>
            </React.Fragment>

        )
    }

    mapField(column) {
        return column;
    }

    selectBuilding = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Kein Gebäude ausgewählt. Wählen Sie ein Gebäude aus der Liste aus"}
                        title1={"Gebäude"}
                        title2={"Vorhandene Gebäude"}
                        columns={[
                            {
                                title: "Adresse",
                                hidden: false,
                                filtering: true,
                                field: "street",
                                render: rowData => { return rowData ? `${rowData.street ? rowData.street : ''}, ${rowData.zipCode ? rowData.zipCode : ''} ${rowData.place ? rowData.place : ''}` : null },
                            },

                        ]}
                        chipIcon={<AppartmentIcon />}
                        chipLabel={() => { return `${this.state.buildingDetails.street}` }}
                        selected={this.state.building}
                        filtering={true}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    const orderBy = '[{column: "id", direction: ASC}]'
                                    query["filters"].push({ column: { field: "tenant" }, operator: '=', value: this.state.tenant })
                                    const where = helper.whereString(query["filters"], this.mapField, ["tenant"]);
                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                        query {
                                            buildings(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Building {
                                                    id
                                                    street
                                                    zipCode
                                                    place
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });

                                    resolve({
                                        page: query.page,
                                        data: result.data.buildings.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    street: element.street,
                                                    zipCode: element.zipCode,
                                                    place: element.place
                                                };
                                            }),
                                        totalCount: result.data.buildings.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        actions={
                            []
                        }
                        onAdd={this.onAddBuilding}
                        onDelete={this.onDeleteBuilding}
                    />
                </Container>
            </React.Fragment>
        )
    }

    selectParcel = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Keine Wohnung ausgewählt. Wählen Sie eine Wohnung aus der Liste aus"}
                        title1={"Wohnung"}
                        title2={"Vorhandene Wohnungen"}
                        columns={[
                            {
                                title: "Etage",
                                hidden: false,
                                filtering: true,
                                field: "name"
                            },

                        ]}
                        chipIcon={<MeetingRoomIcon />}
                        chipLabel={() => { return this.state.parcelDetails.name }}
                        selected={this.state.parcel}
                        filtering={true}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {
                                    query["filters"].push({ column: { field: "building" }, operator: '=', value: this.state.building })
                                    const orderBy = '[{column: "id", direction: ASC}]'
                                    const where = helper.whereString(query["filters"], this.mapField, ["building"]);

                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                            query {
                                                parcels(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Parcel {
                                                    id
                                                    name
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });

                                    resolve({
                                        page: query.page,
                                        data: result.data.parcels.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    name: element.name,
                                                };
                                            }),
                                        totalCount: result.data.parcels.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        actions={[]}
                        onAdd={this.onAddParcel}
                        onDelete={this.onDeleteParcel}
                    />
                </Container>
            </React.Fragment>
        )
    }

    setTapName = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <TextField
                        autoFocus={true}
                        id="outlined-multiline-static"
                        label={i18n.get("tapWizard.step.0")}
                        variant="outlined"
                        value={this.state.tapName}
                        onChange={e => { this.setState({ tapName: e.target.value }) }}
                    />
                </Container>
            </React.Fragment>
        )
    }

    setValveName = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <TextField
                        autoFocus={true}
                        id="outlined-multiline-static"
                        label={i18n.get("tapWizard.step.1")}
                        multiline
                        rows="1"
                        variant="outlined"
                        value={this.state.valveName}
                        onChange={e => { this.setState({ valveName: e.target.value }) }}
                    />
                </Container>
            </React.Fragment>
        )
    }

    setFaucetName = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <TextField
                        autoFocus={true}
                        id="outlined-multiline-static"
                        label={i18n.get("tapWizard.step.2")}
                        variant="outlined"
                        value={this.state.faucetName}
                        onChange={e => { this.setState({ faucetName: e.target.value }) }}
                    />
                </Container>
            </React.Fragment>
        )
    }
    selectTenant = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Kein Mieter ausgewählt. Wählen Sie einen Mieter aus der Liste aus"}
                        title1={"Mieter"}
                        title2={"Vorhandene Mieter"}
                        columns={[
                            {
                                title: "Kunde",
                                hidden: false,
                                filtering: true,
                                field: "company"
                            },
                            {
                                title: "Kundennummer",
                                hidden: false,
                                filtering: false,
                                field: "id"
                            },


                        ]}
                        deleteAllLabel="Mieter entfernen"
                        chipIcon={<ContactMailIcon />}
                        chipLabel={() => { return `${this.state.tenantDetails.company} (${this.state.tenantDetails.id})` }}
                        selected={this.state.tenant}
                        filtering={true}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    const orderBy = '[{column: "id", direction: ASC}]'
                                    const where = helper.whereString(query["filters"], this.mapField);

                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                        query {
                                            tenants(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Tenant {
                                                    id
                                                    company
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });


                                    resolve({
                                        page: query.page,
                                        data: result.data.tenants.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    company: element.company,
                                                };
                                            }),
                                        totalCount: result.data.tenants.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        actions={[]}
                        onAdd={this.onAddTenant}
                        onDelete={this.onDeleteTenant}
                    />
                </Container>
            </React.Fragment>
        )
    }
    render() {
        return (
            <Dialog
                maxWidth={"lg"}
                fullWidth={true}
                open={this.props.open}
                keepMounted
                disableBackdropClick={true}
                onClose={this.onClose}
                fullScreen={false}
            >

                <DialogTitle>
                    <React.Fragment>
                        {i18n.get("tapWizard.title")}
                        <Stepper activeStep={this.state.activeStep}>
                            {this.state.steps.map(label => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </React.Fragment>
                </DialogTitle>
                <DialogContent>
                    {this.getStepContent(this.state.activeStep)}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose} color="primary">
                        {i18n.get("tapWizard.cancel")}
                    </Button>
                    {this.state.activeStep > 0 &&
                        <Button onClick={this.onPrevious} color="primary">
                            {i18n.get("tapWizard.previous")}
                        </Button>
                    }
                    {this.state.activeStep >= 0 && this.state.activeStep < (this.state.steps.length - 1) &&
                        <Button onClick={this.onNext} color="primary" disabled={!this.nextPossible()}>
                            {i18n.get("tapWizard.next")}
                        </Button>
                    }
                    {this.state.activeStep === (this.state.steps.length - 1) &&
                        <Button onClick={this.onSave} color="primary">
                            {i18n.get("tapWizard.save")}
                        </Button>
                    }
                </DialogActions>

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </Dialog>
        );
    }
}

TapWizard.propTypes = {
    classes:
        PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TapWizard)
